import { EventBase, User } from "@vp/models";

export class UserChangedEvent extends EventBase<Partial<User>> {
  constructor(user: Partial<User>) {
    super();
    this.args = user;
  }
}
